/**
 * Front-end script for analytics
 */

import { delay } from './blocks/utils/general-utils';
import { trackPageViews } from './analytics';

/**
 * init
 *
 * Run the script
 */
const init = () => {
  handleOverlayOnPageLoad();
  trackPageViews();
};

const handleOverlayOnPageLoad = () => {
  const overlay = document.querySelector( '.site-overlay' );
  if ( ! overlay ) {
    return;
  }
  delay( 1000 )
    .then( () => {
      overlay.classList.add( 'hidden' );
      overlay.classList.remove( 'is-visible' );
    });
};

export { init };
